import React from "react";
import { Wrapper } from "./styled";
import { Column } from "../../../../styled";
import { ITEMS } from "./../../../../constants";

const MainColumn = () => {
  return (
    <Wrapper>
      <Column>{ITEMS}</Column>
    </Wrapper>
  );
};

export default MainColumn;
